import { autoserialize, autoserializeAs } from 'cerialize';
import { EqualityInterface } from '@uzurv/rideWss/app/interfaces';
import { DateUtil } from '@uzurv/rideWss/app/util/date.util';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util/is-null-or-defined';

export class AbstractModel implements EqualityInterface<AbstractModel> {
  @autoserialize
  id: number;

  @autoserializeAs(Date)
  createdDate: Date;

  @autoserializeAs(Date)
  modifiedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: AbstractModel, json: any): void {
    if (!isNullOrUndefined(instance.createdDate)) {
      json.createdDate = DateUtil.serializeDate(instance.createdDate);
    }
    if (!isNullOrUndefined(instance.modifiedDate)) {
      json.modifiedDate = DateUtil.serializeDate(instance.modifiedDate);
    }
  }

  static OnDeserialized(instance: AbstractModel, json: any): void {
    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['modifiedDate'])) {
      instance.modifiedDate = DateUtil.deserializeDate(json['modifiedDate']);
    }
  }

  /**** Equality ****/

  equals(comparisonObject: AbstractModel): boolean {
    return isNullOrUndefined(comparisonObject) ? false : this.id === comparisonObject.id;
  }

  /**** Operations ****/

  isCreated(): boolean {
    return !isNullOrUndefined(this.id);
  }
}
